import React from 'react';
import { Modal } from '@monitfy/ds';
import { Flex } from 'rebass';
import { Typography } from '@lomadee/design-system';
import { ModalCloseButton } from '@plug/domains/organization/components/subscription/components/credit-card-modal/styles';
import { SignInWithSSOResponse } from '../../graphql/mutations/signin-sso-mutation';
import { ConflictItem } from './style';

type SsoConflictModalProps = {
  conflicts: SignInWithSSOResponse['signInWithSSO']['conflict']['items'];
  open?: boolean;
  onChooseAccount: (userId: string) => void;
};

export const SsoConflictModal = ({ conflicts, open, onChooseAccount }: SsoConflictModalProps) => {
  return (
    <Modal.Dialog open={open}>
      <Modal.Overlay>
        <Modal.Content style={{ maxWidth: '524px', height: 'auto', padding: 0 }}>
          <Flex padding="24px" alignItems="center" justifyContent="space-between">
            <Modal.Title>
              <Typography color="textNeutralDefault" size="20" fontWeight={500} lineHeight="28">
                Conflitos encontrados
              </Typography>
            </Modal.Title>

            <ModalCloseButton>
              <Modal.Close />
            </ModalCloseButton>
          </Flex>

          <Flex paddingX={16}>
            <Typography color="textNeutralDefault" size="16" fontWeight={500} lineHeight="20">
              Encontramos duas contas com o mesmo id de consultora. Escolha uma para vincular com a
              sua conta do portal, a outra permanecerá acessível através de e-mail e senha.
            </Typography>
          </Flex>

          <Flex padding="24px" flexDirection="column" style={{ gap: '16px' }}>
            {conflicts.map(item => (
              <ConflictItem
                key={item.email}
                padding="16px"
                flexDirection="column"
                onClick={() => onChooseAccount(item.id)}
              >
                <Typography color="textNeutralDefault" size="16" fontWeight={500}>
                  {item.email}
                </Typography>
                <Typography color="textNeutralSubtle" size="12" fontWeight={500}>
                  {item.document}
                </Typography>
              </ConflictItem>
            ))}
          </Flex>
        </Modal.Content>
      </Modal.Overlay>
    </Modal.Dialog>
  );
};
